import { useTranslations } from "next-intl";
import Image from "next/image";
import React from "react";

export default function Header() {
  const t = useTranslations("ez_credit");
  return (
    <>
      <div className="grid grid-cols-12 relative   gap-1 lg:h-[750px] pt-28 lg:pt-1 ">
        <div className="col-span-12 lg:col-span-6 -mt-5 lg:mt-0  flex flex-col justify-center">
          <div className=" h-[111px] w-[58px]  relative mb-8 mx-auto lg:mx-0">
            <Image src="/projects/ezcreditLOgo.png" layout="fill" />
          </div>
          <div className="mb-6 ">
            <h1 className="text-white font-[700] text-[32px] lg:text-[40px]">
              {t("what_ez.title")}
            </h1>
            <hr className="h-[5px] w-[138px] rounded-[22.5px] bg-white" />
          </div>
          <div className="max-w-[585px] min-w-[270px]">
            <p className="pb-3 font-[700] lg:font-[400] text-[14px] lg:text-[18px]  text-white leading-[20px] lg:leading-[26px] text-justify">
              {t("what_ez.header")}
            </p>
            <p className="font-[700] lg:font-[400] text-[14px] lg:text-[18px]  text-white leading-[20px] lg:leading-[26px] text-justify">
              {t("what_ez.description")}
            </p>
          </div>
        </div>
        <div className="col-span-12 lg:col-span-6">
          <div className="flex justify-center items-center h-full w-full">
            <div className=" relative w-[346px] h-[283px] lg:h-[469px] lg:w-[565px]">
              <Image src="/projects/heroheader.png" layout="fill" alt="" />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
